import { h } from 'preact';
import React, { Component } from 'react';

import Accordion from './Accordion';

import { StacksSettings } from './StacksSettings';

import './Stacks.css';

const fakeStacks = [
  { name: 'Category Name', description: 'Custom category #1 description', type: 'CUSTOM' },
  { name: 'Stack Name', description: 'Custom stack description', type: 'CUSTOM_STACK' },
  { name: 'IAB Purpose', description: 'IAB purpose description', type: 'IAB_PURPOSE' },
  { name: 'IAB Stack', description: 'IAB stack description', type: 'IAB_STACK' }
];

export class Stacks extends Component {
  state = {
    stacks: [{ name: 'Loading...', description: '', type: '' }],
    loading: true
  }

  componentDidMount = () => {
    this.loadStacks();
  }

  componentDidUpdate = (prevProps) => {
    const { stacksData, language, refetchStacks } = this.props;
    
    if ((stacksData && this.state.stacks === fakeStacks) && !refetchStacks) {
      this.setState({ stacks: stacksData });
    };

    if (language !== prevProps.language) {
      this.loadStacks();
    };
  }

  loadStacks = () => {
    const {
      cmpv2Origin,
      siteId,
      preloadMsg,
      language,
      refetchStacks,
      stacksData,
      setVendorCount,
    } = this.props;

    // IF MESSAGE ID
    if ((siteId && !preloadMsg) || (siteId && refetchStacks) || (!stacksData && preloadMsg)) {
      const languageToFetch = language;
      fetch(`${cmpv2Origin}/vendor-list/categories?siteId=${siteId}${languageToFetch ? `&consentLanguage=${languageToFetch.toLowerCase()}` : ''}`, {
        insecure: true
      })
        .then(r => r.json())
        .then(data => {
          try {
            this.setState({ stacks: data.categories || fakeStacks, loading: false });
            setVendorCount(data.allVendorCount, data.iabVendorCount)
          } catch (e) {
            this.defaultStacks();
          }
        });
    } else {
      this.defaultStacks();
    }
  }

  defaultStacks = () => {
    this.setState({ stacks: fakeStacks, loading: false });
  }

  render() {
    const Settings = new StacksSettings(this.props.component.settings);

    const accordionStyles = {
      ...Settings.accordionsSpacing,
      ...Settings.accordionsFont
    };
    const panelStyles = {
      ...Settings.panelSpacing,
      ...Settings.panelFont
    };

    const sectionStyles = {};
    sectionStyles.minHeight = Settings.minHeight.type === 'auto' ? 'auto' : Settings.minHeight.value + Settings.minHeight.type;
    sectionStyles.maxHeight = Settings.maxHeight.type === 'auto' ? 'auto' : Settings.maxHeight.value + Settings.maxHeight.type;


    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (this.props.dev) {
      devActions = { ...this.props.dev.hover };
      selected = this.props.dev.current === path;
    }

    const className = 'message-component message-stacks no-children' + this.props.className;
    return (
      <div className={selected ? className + ' on-active' : className} path={this.props.dev ? path : null} {...devActions}>
        <div className="stack-container" style={sectionStyles}>
          {this.state.stacks.map((s, i) => (
            <Accordion
              key={`stack-${i}`}
              stack={s}
              panelStyles={panelStyles}
              accordionStyles={accordionStyles}
              dev={this.props.dev}
              loading={this.state.loading}
            />
          ))}
        </div>
      </div>
    );
  }
}
